module.exports = function() {
  return new Worker(__webpack_public_path__ + "f46be30bd5b28711375b.worker.js");
};